import { MenuType } from "@/types/menu";
import { ShoppingBag, StoreIcon } from "lucide-react";

export const orderTypeOptions: {
  label: string;
  icon: React.ReactNode;
  value: MenuType;
}[] = [
  {
    label: "Dine In",
    icon: <StoreIcon className="h-10 w-10" strokeWidth={1} />,
    value: "DINE_IN",
  },
  {
    label: "Take-away",
    icon: <ShoppingBag className="h-10 w-10" strokeWidth={1} />,
    value: "TAKE_AWAY",
  },
];
